import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TextMaskModule } from 'angular2-text-mask';
import { SharedModule } from '../../../../shared/shared.module';
import { EditCaptainsComponent } from './edit-captains.component';
import { EditCaptainsRoutingModule } from './edit-captains-routing.module';
import { EditCaptainsResolve } from './edit-captains.resolve';
import { EditProfileModule } from '../../../profile/edit-profile/edit-profile.module';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    FormsModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    FlexLayoutModule,
    TextMaskModule,
    SharedModule,
    EditCaptainsRoutingModule,
    MatSlideToggleModule,
    MatDialogModule,
    EditProfileModule,
  ],
  declarations: [EditCaptainsComponent],
  entryComponents: [],
  exports: [EditCaptainsComponent],
  providers: [EditCaptainsResolve],
})
export class EditCaptainsModule {}
